import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {MapChart} from 'angular-highcharts';
import {Axis, PointOptionsObject, SeriesMapDataOptions, SeriesOptionsType} from 'highcharts';
import * as worldMap from '@highcharts/map-collection/custom/world.geo.json';
import {IntelligenceData} from '../../../models/intelligence-data.interface';
import {MessageService} from '../../../../shared/services/message.service';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/services/auth.service';

@Component({
  selector: 'app-weee-treatment-standard-mandatory-map-chart',
  templateUrl: './weee-treatment-standard-mandatory-map-chart.component.html',
  styleUrls: ['./weee-treatment-standard-mandatory-map-chart.component.scss']
})
export class WeeeTreatmentStandardMandatoryMapChartComponent implements OnInit, OnChanges {

  textBelow!: string;
  chart!: MapChart;
  chartData!: SeriesOptionsType[];
  textBelowCode = 'intelligence.Country.WeeeTreatmentStandardMandatory.textBelow';
  isAdmin!: boolean;

  @Input()
  title!: string;
  @Input()
  subtitle!: string;
  @Input()
  data!: IntelligenceData[];

  constructor(private readonly messageService: MessageService,
              private readonly router: Router,
              private authService: AuthService) {
  }

  ngOnInit(): void {
    this.isAdmin = this.authService.getUserRoles().includes('WF_ADMIN');
    this.messageService.getDialogInfo(this.textBelowCode).subscribe((data) => {
      if (data !== null) {
        this.textBelow = data.description;
      }
    });
  }

  ngOnChanges(): void {
    if (this.data) {
      this.chartData = this.convertToChartData();
      this.chart = new MapChart({
        chart: {
          map: worldMap
        },
        title: {
          text: this.title
        },
        subtitle: {
          text: this.subtitle
        },
        mapNavigation: {
          enabled: true
        },
        legend: {
          enabled: false
        },
        exporting : {
          csv: {
            columnHeaderFormatter: (item: any, key: any) => {
              if (!item || item instanceof Axis) {
                return 'Country';
              } else {
                return item.name;
              }
            }
          },
          buttons: {
            contextButton: {
              menuItems:  ['viewFullscreen', 'printChart', 'separator', 'downloadPNG', 'downloadJPEG', 'downloadPDF', 'downloadSVG',
                'downloadCSV', 'viewData'],
            }
          },
          menuItemDefinitions: {
            downloadCSV: {
              text: 'Download data'
            }
          }
        },
        tooltip: {
          formatter(): string[] | undefined {
            if (this.point.name) {
              const pointOptions = this.point as PointOptionsObject;
              return ['<div class="center"><b>' + this.point.name + '</b></div>',
                `<br> - Response: ${pointOptions.custom?.answer} <br>` +
                `- Year: ${pointOptions.custom?.year} <br>` +
                (`- Total "yes": ${pointOptions.custom?.totalYes} <br>`) +
                (`- Total "no": ${pointOptions.custom?.totalNo}<br>`)

              ];
            }
            // If not null, use the default formatter
            // return tooltip.defaultFormatter.call(this, tooltip);
            return undefined;
          }
        },
        credits: {
          text: '© WEEE Forum Key Figures | Highcharts.com'
        },
        series: this.chartData
      });
    }
  }

  editTextBelow(): void {
    this.router.navigate(['/admin/chart-labels'], {state: { code: this.textBelowCode }}).then(
      () => {
        // do nothing
      }
    );
  }

  private convertToChartData(): SeriesOptionsType[] {
    this.chart?.ref?.hideData();

    const totalYes = this.data.filter(item => item.answer.toLowerCase().includes('yes')).length;
    const totalNo = this.data.filter(item => item.answer.toLowerCase().includes('no')).length;

    const chartData = [] as SeriesOptionsType[];
    chartData.push({
      name: 'Mandatory WEEE treatment standards',
      joinBy: ['hc-key', 'key'],
      type: 'map',
      data: this.data.map(item => ({
        key: item.countryCode.toLowerCase(),
        value: item.answer || undefined,
        color: item.answer === 'Yes, WEEELABEX' ? '#6db530' :
          (item.answer === 'Yes CENELEC' ? '#B1F40B' :
            (item.answer === 'Yes, WEEELABEX and CENELEC' ? '#1E9700' :
              (item.answer === 'Yes, other standards' ? '#01E87C' :
                (item.answer === 'No' ? '#FF0000' : '#000')))),
        custom: {year: item.year, answer: item.answer, totalResponses: item.totalResponses, totalYes, totalNo}
      } as SeriesMapDataOptions))
    });
    return chartData;
  }

}
